export default __webpack_public_path__ + "static/media/IMG_9991.e3429287.webp";